<script lang="ts">
    import "video.js/dist/video-js.css"
    import { onMount } from "svelte"

    let videoE: HTMLVideoElement

    if (typeof window !== "undefined") {
        onMount(() => {
            // @ts-ignore
            import("video.js/dist/video.es").then((m) => {
                console.log("videojs loaded")
                const videojs = m.default
                videojs(videoE, {}, function () {})
            })
        })
    }

    export let src: string
    export let type = "application/x-mpegURL"
    export let poster: string = null
    export let preload = "auto"
    export let controls = true
    export let width: string = null
    export let height: string = null
    export let slot: string = null
    export let fluid = false
    export let autoplay = false
    export let loop = false
    export let muted = true

    $: if (src?.endsWith(".mp4")) {
        type = "video/mp4"
    } else if (src?.endsWith(".webm")) {
        type = "video/webm"
    } else if (src?.endsWith(".ogv")) {
        type = "video/ogg"
    } else if (src?.endsWith(".m3u8")) {
        type = "application/x-mpegURL"
    }
</script>

<!-- svelte-ignore a11y-media-has-caption -->
<video
    bind:this="{videoE}"
    class="video-js vjs-16-9 {$$props.class}"
    data-setup="{JSON.stringify({ fluid: !!fluid })}"
    {controls}
    {poster}
    {preload}
    {width}
    {height}
    {autoplay}
    {loop}
    {muted}
>
    <source {src} {type} />
    {slot}
    <p class="vjs-no-js">
        To view this video please enable JavaScript, and consider upgrading to a web browser that
        <a href="https://videojs.com/html5-video-support/" target="_blank" rel="noreferrer">supports HTML5 video</a>
    </p>
</video>
